import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const CampaignView = React.lazy(() => import('components/Campaign/View/View'));

function ScreensTraditionalCampaignView(params: Readonly<RoutePrivateProps>) {
  const id = Number(params.id);

  return (
    <BaseLayout>
      <DocumentTitle>Campaigns</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <CampaignView key={id} id={id} />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensTraditionalCampaignView;
